import type { StyleLibrary } from "schemas/generated/project";

export function themeToStyleLibrary(theme: string): StyleLibrary {
  const themeFonts = {
    mono: {
      header: "Instrument Serif",
      body: "Inter",
    },
    modern: {
      header: "Helvetica Neue",
      body: "Arial",
    },
    bold: {
      header: "Impact",
      body: "PT Mono",
    },
    natural: {
      header: "Raleway",
      body: "Sansation",
    },
  };

  const fonts = themeFonts[theme as keyof typeof themeFonts] ?? themeFonts.mono;

  const baseTypography = {
    h1: {
      name: fonts.header,
      url: "",
      size: 48,
      weight: 700,
      lineHeight: 0,
      letterSpacing: 0,
    },
    h2: {
      name: fonts.header,
      url: "",
      size: 32,
      weight: 500,
      lineHeight: 0,
      letterSpacing: 0,
    },
    h3: {
      name: fonts.header,
      url: "",
      size: 28,
      weight: 500,
      lineHeight: 0,
      letterSpacing: 0,
    },
    h4: {
      name: fonts.header,
      url: "",
      size: 24,
      weight: 500,
      lineHeight: 0,
      letterSpacing: 0,
    },
    body: {
      name: fonts.body,
      url: "",
      size: 16,
      weight: 400,
      lineHeight: 0,
      letterSpacing: 0,
    },
  };

  const themeColors = {
    mono: {
      neutrals: {
        light: "#FFFFFF",
        subtle: "#F2F2F2",
        muted: "#DDDDDD",
        dark: "#000000",
      },
      brand: {
        primary: {
          color: "#000000",
          name: "Primary",
        },
        secondary: {
          color: "#A9A9A9",
          name: "Secondary",
        },
        tertiary: {
          color: "",
          name: "",
        },
        accent: {
          color: "",
          name: "",
        },
      },
    },
    modern: {
      neutrals: {
        light: "#FFFFFF",
        subtle: "#FAFAFA",
        muted: "#EDEDED",
        dark: "#000000",
      },
      brand: {
        primary: {
          color: "#FF5C1C",
          name: "Primary",
        },
        secondary: {
          color: "#FFF7F4",
          name: "Secondary",
        },
        tertiary: {
          color: "",
          name: "",
        },
        accent: {
          color: "",
          name: "",
        },
      },
    },
    bold: {
      neutrals: {
        light: "#FFFFFF",
        subtle: "#FFFCFA",
        muted: "#F6E9E0",
        dark: "#000000",
      },
      brand: {
        primary: {
          color: "#D0F491",
          name: "Primary",
        },
        secondary: {
          color: "#E9D5FF",
          name: "Secondary",
        },
        tertiary: {
          color: "",
          name: "",
        },
        accent: {
          color: "",
          name: "",
        },
      },
    },
    natural: {
      neutrals: {
        light: "#FFFFFF",
        subtle: "#FFFAF5",
        muted: "#FFF1E5",
        dark: "#3E2003",
      },
      brand: {
        primary: {
          color: "#C8D5AC",
          name: "Primary",
        },
        secondary: {
          color: "#D97B5C",
          name: "Secondary",
        },
        tertiary: {
          color: "",
          name: "",
        },
        accent: {
          color: "",
          name: "",
        },
      },
    },
  };

  const colors =
    themeColors[theme as keyof typeof themeColors] ?? themeColors.mono;

  return {
    colors,
    typography: baseTypography,
    cornerRounding: 8,
  };
}
